import * as yup from "yup";
import { validationNotEmpty } from "./defaultValidations";

export default yup.object({
  domainAutCert: validationNotEmpty("Domain Authority Certificate Name"),
  certLvl: validationNotEmpty("Certificate Level"),
  status: validationNotEmpty("Status"),
  updatedDate: validationNotEmpty("Updated Date"),
  createdDate: validationNotEmpty("Created Date"),
});
